import { SVGProps } from "react";

const Ellipse = ({
  fill = "#27231F",
  stroke = "#27231F",
  ...props
}: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={87}
    height={88}
    viewBox="0 0 87 88"
    fill="none"
    {...props}
  >
    <circle
      cx={43.709}
      cy={44.257}
      r={39.958}
      fill={fill}
      stroke={stroke}
      strokeWidth={6.645}
    />
  </svg>
);
export default Ellipse;
